import { Tax } from "./tax";
import { ModifierGroupItem } from "./modifiergroup";
import { Printer } from "./printer";
import { ViewMode } from "../constants/enum.pos";
import { PagingResponse } from "./pagination";
import { SmartSearchModel } from "src/app/core/smartsearch/smartsearch";
import { Unit } from "./unit";

export interface ItemBase {
	barCode: string;
	btnColor: string;
	buyPrice: number;
	canDiscount: boolean;
	discountRate: number;
	id: number;
	imageId: number;
	isSetMenu: boolean;
	isVisible: boolean;
	name: string;
	itemId: string;
	nameCn: string;
	nameEn: string;
	nameVi: string;
	parentSetMenuId: number;
	price: number;
	reportingGroup: string;
	showImageOnly: boolean;
	sortOrder: number;
	textColor: string;
	kitchenDelayWarningSeconds: number;
	isSum: boolean;
}

export interface ItemList extends ItemBase {
	menuGroupName: string;
	printerGroupName: string;
	taxName: string;
	parentSetMenuName: string;
	unitName: string;
}

export interface ItemGetById extends ItemBase {
	menuGroupId: number;
	modifierGroups: ModifierGroupItem[];
	printerGroup: Printer;
	tax: Tax;
	unit: Unit;
}

export interface ItemForDetail extends ItemBase {
	menuGroupId: number;
	printerGroupId: number;
	taxId: number;
	unitId: number;
}



export interface ItemDataView {
	itemId: number;
	viewMode: ViewMode;
	items: ItemList[];
}

export interface ItemResponse extends PagingResponse {
	data: ItemList[];
}

export class ItemSearchRequest extends SmartSearchModel {
	menuGroupId: number = null;
	setMenuId: number = null;
	isSetMenu: boolean = null;
}

export class ItemSortOrderRequest {
	menuGroupId: number = null;
	data: ItemSortOrderDetailRequest[] = [];
}

export interface ItemSortOrderDetailRequest {
	id: number;
	sortOrder: number;
}

export interface SetMenu {
	id: number;
	name: string;
}
